import { nullable } from "@auditcloud/shared/lib/types/common";
import { WatchedDocument, unlistenerFunction } from "@/utils/firestore";
import { TodoMap } from "@auditcloud/shared/lib/utils/type-guards";

export class CurrentTemplatesState {
  Documents: WatchedDocument<TodoMap>[] = [];
  DocumentsUnlistener: nullable<unlistenerFunction> = null;
  loadedNewQuery: boolean = true;
}
